export default __webpack_public_path__ + "static/challenge-empty-state-cf5380b4abb85878f862c9ea6f1b5de7.svg";